import React from 'react';

import {
  Breakpoints,
  FindCar,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

import { StyledNoDealersContainer, StyledNoDealersIcon } from './styles';

interface NoDealersFoundProps {
  translationHandler: (key: string) => string;
}

export const NoDealersFound = ({ translationHandler }: NoDealersFoundProps) => (
  <StyledNoDealersContainer role="status" aria-live="polite" data-testid="no-dealers-found">
    <StyledNoDealersIcon aria-hidden="true">
      <FindCar variant="large" />
    </StyledNoDealersIcon>

    <h2>
    <TextCustom
      appearance={TextAppearance.headline300}
      style={{
        [Breakpoints.default]: {
          textAlign: TextAlignment.center,
          fontWeight: TextWeight.regular,
          color: TextColor.primary,
          lineHeight: TextLineHeight.TextLineHeight32,
        },
      }}
    >
      {translationHandler('manageDealer.noDealers.title')}
    </TextCustom>
    </h2>

    <TextCustom
      appearance={TextAppearance.copy200}
      style={{
        [Breakpoints.default]: {
          textAlign: TextAlignment.center,
          fontSize: TextSize.TextSize16,
          fontWeight: TextWeight.regular,
          color: TextColor.secondary,
          lineHeight: TextLineHeight.TextLineHeight24,
        },
      }}
    >
      {translationHandler('manageDealer.noDealers.body')}
    </TextCustom>
  </StyledNoDealersContainer>
);
